module.exports = "/shifts/components/dynamicLaborValueComponent-630ca3.html";